import * as pms from "./typescript/PriceModeAppShellIntegration/PriceModeSettings";
pms.MPC_PricemodeSettingModule.espp_mpc_default_pricemode = "Gross";
import "./typescript/PriceModeAppShellIntegration/PriceModeAppShellIntegration.ts"